import React, { Component, ErrorInfo, ReactNode } from 'react';

import { Box, Typography } from '@mui/material';

import { Resource } from '../../../common/constants/resource';
import { TaskTypes } from '../../tasks/types/taskTypes';

interface Props {
  children: ReactNode;
  taskType: string;
  taskId: number;
}

interface State {
  hasError: boolean;
}

export class TaskErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      'Task error boundary',
      this.props.taskType,
      this.props.taskId,
      error,
      errorInfo,
    );
  }

  public render() {
    if (this.state.hasError) {
      let taskTitle = 'Task error';
      switch (this.props.taskType) {
        case TaskTypes.EHR:
          taskTitle = Resource.TASK_TITLE_EHR;
          break;
        case TaskTypes.ETI:
          taskTitle = Resource.TASK_TITLE_ETI;
          break;
        case TaskTypes.APS:
          taskTitle = Resource.TASK_TITLE_APS;
          break;
        case TaskTypes.MEDEXAM:
          taskTitle = Resource.TASK_TITLE_MEDEXAM;
          break;
        case TaskTypes.TRL:
          taskTitle = Resource.TASK_TITLE_TRL;
          break;
        case TaskTypes.MVR:
          taskTitle = Resource.TASK_TITLE_MVR;
          break;
        case TaskTypes.MIB:
          taskTitle = Resource.TASK_TITLE_MIB;
          break;
        case TaskTypes.RX:
          taskTitle = Resource.TASK_TITLE_RX;
          break;
        case TaskTypes.DISCLOSURE:
          taskTitle = Resource.TASK_TITLE_DISCLOSURE;
          break;
        case TaskTypes.OTAF_LETTER:
        case TaskTypes.DECLINE_LETTER:
        case TaskTypes.SUBSTANDARD_LETTER:
          taskTitle = Resource.TASK_TITLE_LETTER;
          break;
        case TaskTypes.MIB_CODEBACK:
          taskTitle = Resource.TASK_TITLE_MIB_CODEBACK;
          break;
        case TaskTypes.ORDER_MIB_CODEBACK:
          taskTitle = Resource.TASK_TITLE_ORDER_MIB_CODEBACK;
          break;
        case TaskTypes.LAB_PIQTURE:
          taskTitle = Resource.TASK_TITLE_LAB_PIQTURE;
          break;
        case TaskTypes.MEDICAL_CLAIMS:
          taskTitle = Resource.TASK_TITLE_MEDICAL_CLAIMS;
          break;
        case TaskTypes.SCRIPT_CHECK:
          taskTitle = Resource.TASK_TITLE_SCRIPT_CHECK;
          break;
        case TaskTypes.MIB_CODE_DETAILS:
          taskTitle = Resource.TASK_TITLE_MIB_CODE_DETAILS;
          break;
        case TaskTypes.INSURANCE_LABS:
          taskTitle = Resource.TASK_TITLE_INSURANCE_LABS;
          break;
        case TaskTypes.CRIMINAL_RECORDS:
          taskTitle = Resource.TASK_TITLE_CRIMINAL_RECORDS;
          break;
        case TaskTypes.AUTO_MEDICAL_CLAIMS:
          taskTitle = Resource.TASK_TITLE_AUTO_MEDICAL_CLAIMS;
          break;
      }

      return (
        <Box>
          <Box
            display="flex"
            flexDirection="row"
            ml={-1}
            id={this.props.taskId.toString()}
          >
            <Typography variant="h2">{taskTitle}</Typography>
          </Box>

          <Box
            mt={4}
            mb={6}
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="body2">
              This task cannot be displayed due to an error. We are working to
              fix it.
            </Typography>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}
